import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { NotInterestedActionCompletedData } from "../../not-interested-action/not-interested-action.model";
import { ApplicationDocumentData } from "../../../domain/models/application.model";
import { DownloadRequirementDocumentData, DeleteRequirementDocumentData, SaveRequirementDocumentData, UpdateOfferBundleStatusData, UpdateSubmissionDetailsAppBarTitleData } from "../../../domain/models/submissions.model";
import { take } from "rxjs/operators";

@Injectable()
export class SubmissionDetailsActionsService {
  private readonly markDataAsLoadedSubject: Subject<boolean> = new Subject();
  markDataAsLoaded$: Observable<boolean> = this.markDataAsLoadedSubject.asObservable();
  markDataAsLoaded = (isDataLoaded: boolean): void => this.markDataAsLoadedSubject.next(isDataLoaded);

  private readonly markClosingDocumentsSectionAsInvalidSubject: Subject<boolean> = new Subject();
  markClosingDocumentsSectionAsInvalid$: Observable<boolean> = this.markClosingDocumentsSectionAsInvalidSubject.asObservable();
  markClosingDocumentsSectionAsInvalid = (isInvalid: boolean): void => this.markClosingDocumentsSectionAsInvalidSubject.next(isInvalid);

  private readonly closeSubject: Subject<void> = new Subject();
  close$: Observable<void> = this.closeSubject.asObservable();
  close = (): void => this.closeSubject.next();

  private readonly canDeactivateRequestSubject: Subject<void> = new Subject();
  canDeactivateRequest$: Observable<void> = this.canDeactivateRequestSubject.asObservable();
  canDeactivateRequest = (): void => this.canDeactivateRequestSubject.next();

  private readonly canDeactivateResponseSubject: Subject<boolean> = new Subject();
  canDeactivateResponse$: Observable<boolean> = this.canDeactivateResponseSubject.asObservable();
  canDeactivateResponse = (canDeactivate: boolean): void => this.canDeactivateResponseSubject.next(canDeactivate);

  canDeactivate = (): Observable<boolean> => this.canDeactivateResponse$.pipe(take(1));

  private readonly notInterestedActionCompleteSubject: Subject<NotInterestedActionCompletedData> = new Subject();
  notInterestedActionComplete$: Observable<NotInterestedActionCompletedData> = this.notInterestedActionCompleteSubject.asObservable();
  notInterestedActionComplete = (data: NotInterestedActionCompletedData): void => this.notInterestedActionCompleteSubject.next(data);

  private readonly downloadApplicationDocumentSubject: Subject<ApplicationDocumentData> = new Subject();
  downloadApplicationDocument$: Observable<ApplicationDocumentData> = this.downloadApplicationDocumentSubject.asObservable();
  downloadApplicationDocument = (data: ApplicationDocumentData): void => this.downloadApplicationDocumentSubject.next(data);

  private readonly deleteRequirementDocumentSubject: Subject<DeleteRequirementDocumentData> = new Subject();
  deleteRequirementDocument$: Observable<DeleteRequirementDocumentData> = this.deleteRequirementDocumentSubject.asObservable();
  deleteRequirementDocument = (data: DeleteRequirementDocumentData): void => this.deleteRequirementDocumentSubject.next(data);

  private readonly downloadRequirementDocumentSubject: Subject<DownloadRequirementDocumentData> = new Subject();
  downloadRequirementDocument$: Observable<DownloadRequirementDocumentData> = this.downloadRequirementDocumentSubject.asObservable();
  downloadRequirementDocument = (data: DownloadRequirementDocumentData): void => this.downloadRequirementDocumentSubject.next(data);

  private readonly saveRequirementDocumentsSubject: Subject<SaveRequirementDocumentData[]> = new Subject();
  saveRequirementDocuments$: Observable<SaveRequirementDocumentData[]> = this.saveRequirementDocumentsSubject.asObservable();
  saveRequirementDocuments = (data: SaveRequirementDocumentData[]): void => this.saveRequirementDocumentsSubject.next(data);

  private readonly redirectCustomerOfferDetailsViewSubject: Subject<string> = new Subject();
  redirectCustomerOfferDetailsView$: Observable<string> = this.redirectCustomerOfferDetailsViewSubject.asObservable();
  redirectCustomerOfferDetailsView = (detailsPreviewUrl: string): void => this.redirectCustomerOfferDetailsViewSubject.next(detailsPreviewUrl);

  private readonly updateOfferBundleStatusSubject: Subject<UpdateOfferBundleStatusData> = new Subject();
  updateOfferBundleStatus$: Observable<UpdateOfferBundleStatusData> = this.updateOfferBundleStatusSubject.asObservable();
  updateOfferBundleStatus = (data: UpdateOfferBundleStatusData): void => this.updateOfferBundleStatusSubject.next(data);

  private readonly updateSubmissionDetailsAppBarTitleSubject: Subject<UpdateSubmissionDetailsAppBarTitleData> = new Subject();
  updateSubmissionDetailsAppBarTitle$: Observable<UpdateSubmissionDetailsAppBarTitleData> = this.updateSubmissionDetailsAppBarTitleSubject.asObservable();
  updateSubmissionDetailsAppBarTitle = (data: UpdateSubmissionDetailsAppBarTitleData): void => this.updateSubmissionDetailsAppBarTitleSubject.next(data);
}
